// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amount-text[data-v-167c1bcc] {\n  font-weight: 500;\n  color: #1890ff;\n}\n.table-page-search-wrapper[data-v-167c1bcc] {\n  margin-bottom: 16px;\n}\n.fee-text[data-v-167c1bcc] {\n  font-weight: 500;\n  color: #52c41a;\n  background-color: #f6ffed;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #b7eb8f;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
